module.exports = __webpack_public_path__ + "static/media/Robotic-Arm.04b71cac.jpg";